import { useEffect, useState, useRef } from "react";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";
import CTLTable from "application/components/CTLTable";
import { getColumns, Attributes, operationURLS } from "./model";
import CTLAdvancedFilter from "application/components/CTLAdvancedFilter";
import CTLSelectedDownload from "application/components/CTLSelectDownload";
import CTLNotification from "application/components/CTLNotification";
import { application } from "globals/endpoints";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function OutboundGatewaySummary({
  onLoad,
  pageId,
  searchText,
  registerCallBacks,
  pageName,
}) {
  const [controller, dispatch] = useMaterialUIController();
  const { activePage, tableValue, tableSortColumn, tableColumnDataType } =
    controller;

  const [openFilter, setOpenFilter] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [columns, setColumns] = useState(getColumns());
  const [updateList, setUpdateList] = useState(Date.now());
  const [loading, setLoading] = useState(false);

  const filteredList = getColumns().filter(
    (item) => item.displayInList === true
  );
  const selectedColumnDownload = useRef(
    filteredList && filteredList.map((item) => item.accessor)
  );
  const [sortColumn, setSortColumn] = useState("");
  const [columnDataType, setColumnDataType] = useState("");
  useEffect(() => {
    {
      tableSortColumn != "" && setSortColumn(tableSortColumn);
    }
    {
      tableColumnDataType != "" && setColumnDataType(tableColumnDataType);
    }
  }, [tableSortColumn, tableColumnDataType]);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });
  const isMount = useRef(tableValue);

  const FromCurrentDateTime = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const isoString = `${year}-${month}-${day}`;
    return isoString;
  };

  const ToCurrentDateTime = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const isoString = `${year}-${month}-${day}`;
    return isoString;
  };
  const [advancedFilters, setAdvancedFilters] = useState([
    {
      direction: "from",
      dataType: "date",
      fieldName: "callDate",
      value: FromCurrentDateTime(),
    },
    {
      direction: "to",
      dataType: "date",
      fieldName: "callDate",
      value: ToCurrentDateTime(),
    },
  ]);

  useEffect(() => {
    Attributes && onLoad(Attributes);
    registerCallBacks &&
      registerCallBacks({
        openAdvancedFilter: onOpenFilter,
        openForm: onOpenForm,
        DownloadData: onUpdateDataDownload,
        UpdateTableRecords: DownloadData,
        DownloadPdf: DownloadPdf,
        onRefresh: onRefresh,
      });
  }, [activePage, tableValue]);

  // Refresh Function
  const onRefresh = () => {
    setUpdateList(Date.now);
  };

  function DownloadData() {
    setOpenForm(true);
  }

  function onCloseForm() {
    setOpenForm(false);
  }

  function onOpenFilter() {
    setOpenFilter(true);
  }

  function onOpenForm() {
    setFormData({
      eventTime: Date.now(),
    });
    setOpenForm(true);
  }

  function onCloseFilter() {
    setOpenFilter(false);
  }

  function onApplyFilter(advancedFilters) {
    setAdvancedFilters(advancedFilters);
    setOpenFilter(false);
  }

  const updateColumns = (selectedItems) => {
    const updatedColumns = getColumns().map((column) => {
      return {
        ...column,
        displayInList: selectedItems.includes(column.accessor),
      };
    });
    setColumns(updatedColumns);
    selectedColumnDownload.current = selectedItems;
  };

  // for download CSV Report
  function onUpdateDataDownload() {
    if (
      !selectedColumnDownload.current ||
      selectedColumnDownload.current.length === 0
    ) {
      return setNotify({
        isOpen: true,
        pagename: pageName,
        type: "warning",
        status: "You cann't download more that 10 column in pdf mode",
        message: "Please select 10 relevant column using Coumn Filer option",
      });
    }

    setLoading(true);
    const requestBodyData = {
      sortDirection: "asc",
      sortBy: sortColumn,
      search: searchText,
      sortDataType: columnDataType,
      columnNames: selectedColumnDownload.current,
      advancedFilters: advancedFilters,
    };
    const requestConfig = {
      responseType: "arraybuffer",
    };
    application
      .post(operationURLS.csvDownload, requestBodyData, requestConfig)
      .then((response) => {
        if (response) {
          setLoading(false);
          const blob = new Blob([response.data], { type: "text/csv" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Outbound-Gateway-summary.csv";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);

          setNotify({
            isOpen: true,
            pagename: pageName,
            status: "CSV Download successful",
            type: "success",
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          setNotify({
            isOpen: true,
            pagename: pageName,
            status: "Unable To Download File",
            type: "error",
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  // for Download pdf
  function DownloadPdf() {
    if (
      !selectedColumnDownload.current ||
      selectedColumnDownload.current.length === 0
    ) {
      return setNotify({
        isOpen: true,
        pagename: pageName,
        type: "warning",
        status: "You cann't download more that 10 column in pdf mode",
        message: "Please select 10 relevant column using Coumn Filer option",
      });
    } else if (selectedColumnDownload.current.length > 10) {
      return setNotify({
        isOpen: true,
        pagename: pageName,
        type: "error",
        status: "Select maximum of 10 columns",
      });
    }
    setLoading(true);
    const requestBodyData = {
      sortDirection: "asc",
      sortBy: sortColumn,
      search: searchText,
      sortDataType: columnDataType,
      columnNames: selectedColumnDownload.current,
      advancedFilters: advancedFilters,
    };
    const requestConfig = {
      responseType: "arraybuffer",
      params: {
        reportType: "gatewayOutBoundSummaryPdf",
      },
    };
    application
      .post(operationURLS.pdfDownload, requestBodyData, requestConfig)
      .then((response) => {
        if (response) {
          setLoading(false);
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Outbound-Gateway-summary.pdf";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);

          setNotify({
            isOpen: true,
            pagename: pageName,
            status: "PDF Download successful",
            type: "success",
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          setNotify({
            isOpen: true,
            pagename: pageName,
            status: "Unable To Download File",
            type: "error",
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <MDBox>
      <CTLSelectedDownload
        openForm={openForm}
        columns={getColumns()}
        pageName={pageName}
        onCloseForm={onCloseForm}
        onUpdate={updateColumns}
      />
      <CTLTable
        apiURL={operationURLS.list}
        advancedFilters={advancedFilters}
        columns={columns}
        entriesPerPage={false}
        disablePagination={false}
        canSearch
        defaultSortDirection="asc"
        defaultSortColumn="coralGateway"
        pageId={pageId}
        searchText={searchText}
        hasRowSelection={false}
        updateList={updateList}
        defaultPageSize={20}
      />
      <MDBox
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <CTLAdvancedFilter
          entityName={pageName}
          columns={getColumns()}
          applyFilter={openFilter}
          onApplyFilter={onApplyFilter}
          onCloseFilter={onCloseFilter}
          advancedFilters={advancedFilters}
        />
      </MDBox>
      <MDBox>
        {loading && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100px",
            }}
          >
            <CircularProgress />
          </Box>
        )}
      </MDBox>
      <CTLNotification notify={notify} setNotify={setNotify} />
    </MDBox>
  );
}
